// extracted by mini-css-extract-plugin
export var standaloneTable = "_fg-0";
export var standaloneTableWithBodyFill = "_fg-1";
export var withExtraHeader = "_fg-2";